// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"211":"9042e3a1","321":"4e49ac03","352":"0283a589","463":"59117eef","557":"6d5a96ec","566":"051cc50d","796":"614dbab0"}[chunkId] + ".chunk.css";
};